import { createStore } from 'vuex'
import createVuexPersistedState from 'vuex-persistedstate';
import { LOCAL_STORAGE_KEY } from '@/utils/const';
import { enabledModulesOf } from '@/utils/modules';
import account from './modules/account';
import error from './modules/error';
import employeeAddress from './modules/employee_address';
import employeeEducation from './modules/employee_education';
import employeeLeave from './modules/employee_leave';
import employeePosition from './modules/employee_position';
import employeeSalary from './modules/employee_salary';
import employee from './modules/employee';
import leaveType from './modules/leave_type';
import payrollPeriod from './modules/payroll_period';
import payroll from './modules/payroll';
import holiday from './modules/holiday';
import employeePayroll from './modules/employee_payroll';
import employeeOvertime from './modules/employee_overtime';
import overtimeSetting from './modules/overtime_setting';
import employeeAllowance from './modules/employee_allowance';
import allowanceType from './modules/allowance_type';
import attendanceLog from './modules/attendance_log';
import file from './modules/file';
import stats from './modules/stats';
import bank from './modules/bank';
import employeeBank from './modules/employee_bank';
import employeeContract from './modules/employee_contract';
import department from './modules/department';
import position from './modules/position';
import employeeSalaryPromotion from './modules/employee_salary_promotion';
import payrollComponent from './modules/payroll_component';
import employeePayrollComponent from './modules/employee_payroll_component';
import attendanceSchedule from './modules/attendance_schedule';
import organization from './modules/organization';
import attendanceShift from './modules/attendance_shift';
import employeeAttendanceShift from './modules/employee_attendance_shft';
import leaveRequest from './modules/leave_request';
import leaveBalance from './modules/leave_balance';
import leaveLedger from './modules/leave_ledger';
import guideline from './modules/guideline';
import jobPost from './modules/job_post';
import jobApplication from './modules/job_application';
import project from './modules/project';
import client from './modules/client';
import billingInvoicing from './modules/billing_invoicing';
import invoiceItem from './modules/invoice_item';
import milestone from './modules/milestone';
import projectEmployee from './modules/project_employee';
import projectTransaction from './modules/project_transaction';
import projectFile from './modules/project_file';
import projectEmployeeRole from './modules/project_employee_role';
import fayda from './modules/fayda';
import exportTemplate from './modules/export_template';
import employeeOffboarding from './modules/employee_offboarding';
import employeeOffboardingChecklist from './modules/employee_offboarding_checklist';
import employeeOffboardingTemplate from './modules/employee_offboarding_template';
import knowledgeBaseCategory from './modules/knowledge_base_category';
import knowledgeBaseArticle from './modules/knowledge_base_article';
import reports from './modules/reports';
import chat from './modules/chat';
import drive from './modules/drive';

export default createStore({
  state: {
  },
  getters: {
    calendarSystem: (_state: unknown, getters: { account?: { data?: { organization?: { calendarSystem?: string } } } }) =>
      getters.account?.data?.organization?.calendarSystem || 'GREGORIAN',
    /** Modules the signed in organization is licensed for; drives navigation and route access. */
    enabledModules: (_state: unknown, getters: { account?: { data?: { organization?: { enabledModules?: unknown } } } }) =>
      enabledModulesOf(getters.account?.data?.organization),
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    account,
    allowanceType,
    attendanceLog,
    attendanceSchedule,
    attendanceShift,
    bank,
    department,
    employee,
    employeeAddress,
    employeeAllowance,
    employeeAttendanceShift,
    employeeBank,
    employeeContract,
    employeeEducation,
    employeeLeave,
    employeeOvertime,
    employeePayroll,
    employeePayrollComponent,
    employeePosition,
    employeeSalary,
    employeeSalaryPromotion,
    error,
    fayda,
    file,
    guideline,
    holiday,
    jobApplication,
    jobPost,
    leaveBalance,
    leaveLedger,
    leaveRequest,
    leaveType,
    organization,
    overtimeSetting,
    payroll,
    payrollComponent,
    payrollPeriod,
    position,
    stats,
    project,
    client,
    billingInvoicing,
    invoiceItem,
    milestone,
    projectEmployee,
    projectTransaction,
    projectFile,
    projectEmployeeRole,
    exportTemplate,
    employeeOffboarding,
    employeeOffboardingChecklist,
    employeeOffboardingTemplate,
    knowledgeBaseCategory,
    knowledgeBaseArticle,
    reports,
    chat,
    drive
  },
  plugins: [
    createVuexPersistedState({
      key: LOCAL_STORAGE_KEY,
      storage: window.localStorage,
      paths: ['account'],
    }),
  ],
})
